<template>
  <div class="c-form-control c-form-control__variant--sm">
    <div v-if="!noLabel" class="u-margin-bottom-xsmall">
      <label class="c-form-control__label">
        {{ label }}
        <slot name="label-button"></slot>
      </label>
    </div>
    <v-select
      :data-error="$t('common.required')"
      :class="{
        'vs-invalid': validActivated && !value,
        'vs-valid': validActivated && value,
      }"
      :options="options"
      :placeholder="
        $t('common.choosePlaceholder', {
          label,
        })
      "
      :disabled="disabled"
      @open="$emit('open', search, toggleLoading)"
      ref="select"
      @option:selected="$emit('option:selected', $event)"
      :value="value || null"
      searchable
      @input="$emit('input', $event)"
      @search="SET_SEARCH"
      :clearable="clearable"
      :filter="(option, search) => filterMethods(option, search)"
    >
      <template #option="item">
        <slot
          :item="item"
          v-if="hasSelectedOption"
          name="selected-option"
        ></slot>
        <span v-else> {{ item[optionField] || item.title }}</span>
      </template>
      <template #selected-option>
        <slot
          :item="value"
          v-if="hasSelectedOption"
          name="selected-option"
        ></slot>
        <span v-else>{{ value[optionField] || value.title }} </span>
      </template>
      <template #no-options="{ search }">
        <slot v-if="hasNoOptions" name="no-options" :search="search"></slot>
        <slot v-else-if="has" name="not-found"></slot>
        <div v-else>
          <div class="u-margin-bottom-small u-margin-top-small">
            <img src="@/assets/images/nofound.png" width="40" alt="" />
          </div>
          <small> {{ $t("noFoundData") }}</small>
        </div>
      </template>
      <template #list-header>
        <slot name="list-header"></slot>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    value: {
      default: {},
    },
    options: {
      default: () => [],
    },
    childIndex: {
      default: 0,
    },
    index: {
      default: 0,
    },
    validActivated: {
      default: false,
    },
    disabled: {
      default: false,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    optionField: {
      default: "key",
    },
    label: {
      default: "",
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    searchable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      timeout: -1,
    };
  },
  computed: {
    search() {
      return this.$refs?.select?.search || "";
    },
    hasSelectedOption() {
      return this.$scopedSlots["selected-option"] ? true : false;
    },
    hasNoOptions() {
      return this.$scopedSlots["no-options"] ? true : false;
    },
    hasNotAuth() {
      return this.$scopedSlots["not-auth"] ? true : false;
    },
  },
  methods: {
    SET_SEARCH(search, loading) {
      if (this.searchable) loading(true);
      if (this.timeout !== -1) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("search", search, loading);
      }, 500);
    },
    toggleLoading(e) {
      this.$refs.select.toggleLoading(e);
    },
    filterMethods(options, search) {
      if (this.searchable) return options;
      console.log(options, search, "options", this.optionField);
      return options.filter((option) =>
        String(option[this.optionField] || option?.title)
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    },
    checkSlots() {
      console.log(this.$scopedSlots, "slots");
    },
  },
  mounted() {
    this.checkSlots();
  },
};
</script>

<style></style>
